'use client';

import { IconButton, Popover } from '@mui/material';

import { CloseIcon, mergeSx } from '@abg/kit-base';

import { userStoreSelector } from '../../store';
import { AmazonAccountActionsGroup } from '../AmazonAccountActionsGroup';

import { accountMenuStyling, closeIconStyling } from './account-menu.styling';
import { AccountMenuProps } from './account-menu.types';
import { AccountActions } from './molecules';

export const AccountMenu = ({
  styleParts = {},
  model,
  anchorEl,
  handleClose,
  currentRental,
}: AccountMenuProps) => {
  const userSession = userStoreSelector.use.userSession();

  const { amazonLogin, amazonLinked } = userSession || {};

  return (
    <Popover
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      slotProps={{
        paper: {
          role: 'dialog',
          'aria-label': 'Account menu',
        },
      }}
      sx={mergeSx(accountMenuStyling, styleParts.menuContainer)}
      data-testid="account-menu"
    >
      <IconButton
        onClick={handleClose}
        sx={closeIconStyling}
        aria-label="close"
        data-testid="account-menu-close-btn"
      >
        <CloseIcon stroke="black" strokeWidth="1.5px" />
      </IconButton>

      {!amazonLinked && amazonLogin && (
        <AmazonAccountActionsGroup
          anchorEl={anchorEl}
          handleClose={handleClose}
          amazonSettings={model.amazonSettings}
          styleParts={styleParts}
          i18n={model.i18n}
        />
      )}

      {!(!amazonLinked && amazonLogin) && (
        <AccountActions
          anchorEl={anchorEl}
          handleClose={handleClose}
          model={model}
          styleParts={styleParts}
          currentRental={currentRental}
        />
      )}
    </Popover>
  );
};
